const getters = {
    sidebar: state => state.app.sidebar,
    visitedViews: state => state.app.visitedViews,
    navbarData: state => state.app.navbarData,
    token: state => state.user.token,
    avatar: state => state.user.avatar,
    name: state => state.user.name,
    roles: state => state.user.roles,
    addRouters: state=>state.route_processe.addRouters,
    getHotelOrFootbath: state=>state.app.hotelOrFootbathData,
    getUserInfoOrigin: state=>state.user.userInfo,
    getUserTitle: state=>state.user.userTitle,
    order_router: state=>state.route_processe.order_route,
    revenue_router: state=>state.route_processe.revenue_route,
    list_router: state=>state.route_processe.list_route,
    record_router: state=>state.route_processe.record_route,
    wait_router: state=>state.route_processe.wait_route,
    isOrder: state=>state.app.isOrder,
    waitOrder: state=>state.app.waitOrder,
    the_agent_id: state=>state.user.userInfo.agent_id,
    authUpload: state => state.user.auth.upload,
    authEdit: state => state.user.auth.edit,
    authMessage: state => state.user.auth.message,
    examineRemind: state => state.app.examineRemind,
    whiteListType: state => state.app.whiteListType
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js